import { useTranslation } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import CopyWrapper from "components/Common/CopyWrapper";
import { COLOR_CASH_RECEIPT_TYPE, COLOR_PLAN_PURCHASE_INVOICE_TYPE, ENUM_PLAN_PURCHASE_INVOICE_TYPE, LIST_CASH_RECEIPT_TYPE_OPTION, LIST_PLAN_PURCHASE_INVOICE_TYPE } from "helpers/constans";
import { formatDateStringToKorea } from "helpers/format";
import TaxInvoice from "./TaxInvoice";

export default function GatewayVirtualSection({ dataFormat }: any) {
  const { t, i18n } = useTranslation();


  return (
    <>
      <Col md={4} lg={4}>
        <div className="mb-3 mt-2">
          <Label htmlFor="manufacturer" className="form-label">
            {t("Bank Name")}
          </Label>
          <div className="cursor-pointer">
            <CopyWrapper contentCopy={dataFormat?.gwBankName}>
              {[dataFormat?.gwBankCode, dataFormat?.gwBankName].filter(Boolean)?.join(" - ") || "-"}
            </CopyWrapper>
          </div>
        </div>
      </Col>

      <Col md={4} lg={4}></Col>

      <Col md={4} lg={4}>
        <div className="mb-3 mt-2">
          <Label htmlFor="gwVirtualAccountNo" className="form-label">
            {t("Account Number")}
          </Label>
          <div className="cursor-pointer">
            <CopyWrapper contentCopy={dataFormat?.gwVirtualAccountNo}>
              {`${dataFormat?.gwVirtualAccountNo || "-"}`}
            </CopyWrapper>
          </div>
        </div>
      </Col>

      <Col md={4} lg={4}>
        <div className="mb-3 mt-2">
          <Label htmlFor="gwVirtualAccountName" className="form-label">
            {t("Account Name")}
          </Label>
          <div className="cursor-pointer">
            <CopyWrapper contentCopy={dataFormat?.gwVirtualAccountName}>
              {`${dataFormat?.gwVirtualAccountName || "-"}`}
            </CopyWrapper>
          </div>
        </div>
      </Col>

      <Col md={4} lg={4}>
        <div className="mb-3">
          <Label htmlFor="gwVirtualAccountExpiredAt" className="form-label">
            {t("Account Exp Date")}
          </Label>
          <div>
            {dataFormat?.gwVirtualAccountExpiredAt
              ? formatDateStringToKorea(dataFormat?.gwVirtualAccountExpiredAt)
              : "-"}
          </div>
        </div>
      </Col>

      <Col md={`${dataFormat?.gwReceiptType === ENUM_PLAN_PURCHASE_INVOICE_TYPE.CASH_RECEIPT ? 4 : 12}`} lg={`${dataFormat?.gwReceiptType === ENUM_PLAN_PURCHASE_INVOICE_TYPE.CASH_RECEIPT ? 4 : 12}`}>
        <div className="mb-3 mt-2">
          <Label htmlFor="gwReceiptType" className="form-label">
            {t("Receipt Type")}
          </Label>
          <div className="cursor-pointer">
            {dataFormat?.gwReceiptType ? (
              <span
                className={`rounded-pill badge bg-${
                  COLOR_PLAN_PURCHASE_INVOICE_TYPE[dataFormat?.gwReceiptType] ||
                  "secondary"
                }`}
                style={{
                  fontSize: "0.8rem",
                  lineHeight: 1,
                }}
              >
                {t(
                  LIST_PLAN_PURCHASE_INVOICE_TYPE?.find(
                    (item: any) => item?.value == dataFormat?.gwReceiptType
                  )?.label || ""
                )}
              </span>
            ) : (
              "-"
            )}
          </div>
        </div>
      </Col>
      
      {
        dataFormat?.gwReceiptType === ENUM_PLAN_PURCHASE_INVOICE_TYPE.TAX_INVOICE && (
          <TaxInvoice dataFormat={dataFormat} />
        )
      }

      {
        dataFormat?.gwReceiptType === ENUM_PLAN_PURCHASE_INVOICE_TYPE.CASH_RECEIPT && (
          <>
            <Col md={4} lg={4}>
              <div className="mb-3 mt-2">
                <Label htmlFor="gwVirtualAccountName" className="form-label">
                  {t("Cash Receipt Type")}
                </Label>
                <div>
                  {
                    dataFormat?.cashReceiptType ? (
                      <span
                        className={`rounded-pill badge bg-${
                          COLOR_CASH_RECEIPT_TYPE[
                            dataFormat?.cashReceiptType
                          ] || "secondary"
                        }`}
                        style={{
                          fontSize: "0.8rem",
                          lineHeight: 1
                        }}
                      >
                        {t(
                          LIST_CASH_RECEIPT_TYPE_OPTION?.find(
                            (item: any) =>
                              String(item?.value) ===
                              String(dataFormat?.cashReceiptType)
                          )?.label || ""
                        )}
                      </span>
                    ): "-"
                  }
                </div>
              </div>
            </Col>
            <Col md={4} lg={4}>
              <div className="mb-3 mt-2">
                <Label htmlFor="cashCardNo" className="form-label">
                  {t("Cash Card No")}
                </Label>
                <div className="cursor-pointer">
                  <CopyWrapper contentCopy={dataFormat?.cashCardNo}>
                    {`${dataFormat?.cashCardNo || "-"}`}
                  </CopyWrapper>
                </div>
              </div>
            </Col>
          </>
        )
      }
      
    </>
  );
}
